const PADDING = { default: 'p-4 sm:p-5', compact: 'p-3 sm:p-5', none: '' };

export default function Card({ as: Tag = 'section', padding = 'default', className = '', children, ...rest }) {
  return (
    <Tag
      className={`bg-surface dark:bg-gray-870 rounded-xl border border-gray-200/70 dark:border-gray-600/70 shadow-sm ${PADDING[padding] ?? PADDING.default} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export function CardHeader({ title, description, actions, titleAs: TitleTag = 'h3', className = '' }) {
  return (
    <div className={`flex items-start justify-between gap-3 ${className}`}>
      <div className="min-w-0">
        <TitleTag className="text-[15px] leading-5 font-semibold tracking-tight text-gray-900 dark:text-gray-100">{title}</TitleTag>
        {description && <p className="mt-0.5 text-xs text-gray-500 dark:text-gray-400">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
